<template>
  <div class="tw-w-full tw-p-8">
    <div class="mb-2 tw-text-2xl tw-font-bold">When do you need task to be done?</div>

    <submit-task-select
      :searchable = false
      :options="states.base_data.executionTimes"
      :filter="(option,search) => option.title.toLowerCase().includes(search.toLowerCase())"
    >
      <template v-slot:option="{option}">
        <submit-task-option
          v-on:click.native.prevent="store.selectExecutionTime(option)"
          :isActive="_.get(states.executionTime,'id') === option.id"
          :text="option.title"
        />
      </template>
    </submit-task-select>

    <div class="row" v-show="_.get(states.executionTime,'id')=='' ">
      <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label for="execution_date_from">From</label>
          <input id="execution_date_from" type="date" class="form-control" v-model="states.execution_date_from">

        </div>

      </div>
    <div class="col-sm-12 col-md-6">
        <div class="form-group">
          <label for="execution_date_to">To</label>
          <input id="execution_date_to" type="date" class="form-control" v-model="states.execution_date_to">

        </div>

      </div>
    </div>
   

  </div>
</template>
<script>
  import store from './submit-task-store'
  import SubmitTaskSelect from "./submit-task-select";
  import SubmitTaskOption from "./submit-task-option";
  import DatePick from 'vue-date-pick';


  export default {
    components: {
      SubmitTaskSelect,
      SubmitTaskOption,
    },
    beforeCreate() {
      this.store = store
    },
    data: v => ({
      states: store.states,
    }),
  }
</script>
